import React, { Fragment, useEffect } from 'react';
import { Router } from 'react-router-dom';
import Routes from './components/routing/Routes';
import history from './History';


import { Provider } from 'react-redux';
import store from './store';
import axios from 'axios';
import { loadUser } from './actions/auth';
import { LOGOUT } from './actions/types';
import setAuthToken from './utils/setAuthToken';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import './App.css';


if(localStorage.token){
  setAuthToken(localStorage.token);
}

// Sessione scaduta o revocata: torno al login
axios.interceptors.response.use(response => response, error => {
  if(error.response && error.response.status === 401 && store.getState().auth.isAuthenticated){
    setAuthToken(null);
    store.dispatch({ type: LOGOUT });
  }
  return Promise.reject(error);
});

// Login o logout fatto in un'altra scheda: ricarico per usare l'utente giusto
window.addEventListener('storage', e => {
  if(e.key === 'token' && e.oldValue !== e.newValue){
    window.location.reload();
  }
});



const App = () => {
  useEffect(() => {
    store.dispatch(loadUser());
  }, []);


return(
  <Provider store={store}>
    <Router history={history}>
      <Fragment>
        <ToastContainer
          position="bottom-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          className= "noprint"
        />
        <Routes component={Routes} />
      </Fragment>
    </Router>
  </Provider>
)};


export default App;
